import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'
Vue.use(MLInstaller)

export default new MLCreate({
  initial: 'english',
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('english').create({
      Name: 'Name',
      Description: 'Description',
      WhenDoYouWantToStartACampaign: 'When do you want to start a campaign?',
      StartImmediatelyRunContinuously: 'Start immediately, run continuously',
      SetupStartAndEndDate: 'Setup start and end date',
      Company: 'Company',
      Enabled: 'Enabled',
      DateRange: 'Date range',
      CompanyBudget: 'Company Budget',
      TotalBudget: 'Total Budget',
      DailyBudget: 'Daily Budget',
      DefaultCPV: 'Default CPV',
      CPMBid: 'CPM Bid',
      MinCPV: 'Min CPV',
      MaxCPV: 'Max CPV',
      DailyViews: 'Daily Views',
      CompanyLimits: 'Company Limits',
      ViewsPerIP: 'Views per IP',
      Next: 'Next',
      Prev: 'Prev',
      Offer: 'Offer',
      DaysOfWeek: 'Days of week',
      Keywords: 'Keywords',
      Save: 'Save',
      Update: 'Update',
      Campaign: 'Campaign',
      Ads: 'Ads',
      'Offer-ext': 'Offer-ext'
    })
  ]
})



// WEBPACK FOOTER //
// ./src/utils/ml.js